import React, { ReactNode } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { FaPlus } from 'react-icons/fa';

interface EmptyStateViewProps {
  icon: ReactNode;
  title: string;
  description: string;
  buttonText: string;
  onAction: () => void;
  paperStyles?: Object;
}

const EmptyStateView: React.FC<EmptyStateViewProps> = ({
  icon,
  title,
  description,
  buttonText,
  onAction,
  paperStyles = {}
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        borderRadius: 2,
        backgroundColor: 'background.default',
        border: '1px dashed',
        borderColor: 'divider',
        my: 4,
        ...paperStyles
      }}
    >
      <Box sx={{ mb: 2, color: 'text.secondary', opacity: 0.5 }}>
        {icon}
      </Box>
      
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        {title}
      </Typography>
      
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 450, mb: 3 }}>
        {description}
      </Typography>
      
      <Button
        variant="contained"
        color="primary"
        startIcon={<FaPlus />}
        onClick={onAction}
        size="large"
      >
        {buttonText}
      </Button>
    </Paper>
  );
};

export default EmptyStateView;